import type { Infer } from 'superstruct';
import { number, object, optional, partial, string } from 'superstruct';

import { parsableInteger } from '@adflow/shared/util-superstruct';

export const AddFacebookAdSetBudgetTemplateDto = object({
	id: optional(parsableInteger()),
	budget: number(),
	avbId: string(),
});

export const ViewFacebookAdSetBudgetTemplateDto = object({
	id: number(),
	budget: number(),

	adAccountId: number(),

	adAccount: optional(
		object({
			id: number(),
			name: string(),
			avbId: string(),
		})
	),
});
export type ViewFacebookAdSetBudgetTemplateDto = Infer<
	typeof ViewFacebookAdSetBudgetTemplateDto
>;
export type AddFacebookAdSetBudgetTemplateDto = Infer<
	typeof AddFacebookAdSetBudgetTemplateDto
>;
export const EditFacebookAdSetBudgetTemplateDto = partial(
	AddFacebookAdSetBudgetTemplateDto
);
export type EditFacebookAdSetBudgetTemplateDto = Infer<
	typeof EditFacebookAdSetBudgetTemplateDto
>;
